import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Import Axios
import { useNavigate } from 'react-router-dom';
import './MySubmissions.css';

function MySubmissions() {
    const [mySubmissions, setMySubmissions] = useState([]);
    const navigate = useNavigate(); // Hook for navigation

    useEffect(() => {
        const fetchSubmissions = async () => {
            try {
                // Use Axios to make the HTTP request
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get_user_submissions`, { withCredentials: true });
                setMySubmissions(response.data); // Set data from Axios response
            } catch (error) {
                // With Axios interceptor, you don't need to handle 401 here explicitly
                console.error('There was a problem with the fetch operation:', error);
            }
        };

        fetchSubmissions();
    }, [navigate]);

    const handleSubmissionClick = (submission) => {
        navigate(`/submission-review/${submission.id}`, { state: submission });
    };

    return (
        <div className="my-submissions-container">
            <h1>My Submissions</h1>
            <table className="my-submissions-table">
                <thead>
                    <tr>
                        <th>Time Submitted</th>
                        <th>Question</th>
                        <th>Score</th>
                    </tr>
                </thead>
                <tbody>
                    {mySubmissions.map((submission, index) => (
                        <tr key={index} onClick={() => handleSubmissionClick(submission)}>
                            <td>{submission['Time Submitted']}</td>
                            <td>{`${submission.question_id}: ${submission.Question}`}</td>
                            <td>{submission.Score}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default MySubmissions;
